(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("sbInternalMsgBus"));
	else if(typeof define === 'function' && define.amd)
		define("sbAuthorizationLib", ["sbInternalMsgBus"], factory);
	else if(typeof exports === 'object')
		exports["sbAuthorizationLib"] = factory(require("sbInternalMsgBus"));
	else
		root["sbAuthorizationLib"] = factory(root["sbInternalMsgBus"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__) {
return 